module.exports = __webpack_public_path__ + "img/m.9ad9d116.jpg";